import { CompanyConfig } from '../../datasource/company'

export default CompanyConfig.fromJS({})
